export const userMenuPopupText = {
  profile: 'Profile',
  logOut: 'Log out',
  accountSettings: 'Account Settings',
};
